module.exports = __webpack_public_path__ + "static/media/invoiceStampPDF.17afa9ae.png";